export default __webpack_public_path__ + "static/media/icon-sedans.e7945028.svg";